
const CONFIG = {
  ek: 1,
  t: undefined,
  u: undefined,
  c: 2,
  b: 718,
  bl: 'en_US',
};
// const DOWNLOAD_URL = "https://s3u.kkmoney.ng/lcredit--1500200099-release-v1.0.5-6-20191111-174111-OTHER-----------------------------GP.apk";
const DOWNLOAD_URL = "https://s3u.lcredit.ng/1.3.0-31/lcredit-h5.apk";

let BASE_URL = '';
let VERIFYCODE_IMG_URL = '';

if (process.env.NODE_ENV === 'development') {
  BASE_URL = 'https://ewdlgs.kkmoney.ng/ostrader';
  VERIFYCODE_IMG_URL = 'https://ebjqa.emai888.com/';
  // VERIFYCODE_IMG_URL = 'https://sxapi.weshare.com.cn/';
} else {
  BASE_URL = 'https://japi2.lcredit.ng/ostrader';
  VERIFYCODE_IMG_URL = 'https://sea.lcredit.ng/sea/v1/metrics';
  // BASE_URL = 'https://japi2.flypay.ng/ostrader';
  // VERIFYCODE_IMG_URL = 'https://info.flypay.ng/sea/v1/metrics';
}

export { CONFIG, BASE_URL, DOWNLOAD_URL, VERIFYCODE_IMG_URL };
